import React from "react";
import { format, parse, isValid } from "date-fns";
import { id as idLocale } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

/**
 * DatePicker - Indonesian locale, dd/MM/yyyy display.
 * value: ISO string "YYYY-MM-DD" or "" (controlled)
 * onChange: (isoString | "") => void
 */
export function DatePicker({
  value,
  onChange,
  placeholder = "Pilih tanggal",
  disabled,
  testId,
  allowClear = false,
  className,
}) {
  const date = value ? parse(value, "yyyy-MM-dd", new Date()) : null;
  const valid = date && isValid(date);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          disabled={disabled}
          data-testid={testId}
          className={cn(
            "w-full justify-start font-normal",
            !valid && "text-muted-foreground",
            className,
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {valid ? format(date, "dd MMM yyyy", { locale: idLocale }) : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          locale={idLocale}
          selected={valid ? date : undefined}
          onSelect={(d) => {
            if (!d) {
              if (allowClear) onChange("");
              return;
            }
            onChange(format(d, "yyyy-MM-dd"));
          }}
          initialFocus
        />
        {allowClear && valid && (
          <div className="border-t border-border p-2">
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="w-full text-xs"
              onClick={() => onChange("")}
              data-testid={testId ? `${testId}-clear` : undefined}
            >
              Hapus
            </Button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}

export default DatePicker;
